import { defineMessages } from "react-intl"

export const SUPPLIER_MESSAGES = defineMessages({
    header_supplier_name: {
        id: "supplier.page.supplier_page.listing.supplier_name_label",
        defaultMessage: "Name"
    },
    header_primary_contact_name: {
        id: "supplier.page.supplier_page.listing.supplier_primary_contact_name_label",
        defaultMessage: "Contact Name"
    },
    header_city: {
        id: "supplier.page.supplier_page.listing.supplier_city_label",
        defaultMessage: "City"
    },
    header_phone_number: {
        id: "supplier.page.supplier_page.listing.supplier_phone_number_label",
        defaultMessage: "Phone Number"
    },
    header_created_at: {
        id: "supplier.page.supplier_page.listing.created_at_label",
        defaultMessage: "Created At"
    },
    searchPlaceHolder: {
        id: "supplier.page.supplier_page.listing.listing.placeholder.search_stock_documents",
        defaultMessage: "Search suppliers...",
    },
})

export const CREATE_NEW_SUPPLIER_MESSAGES = defineMessages({
    supplierNameLabel:{
        id: "supplier.page.supplier_page.new.name_label",
        defaultMessage: "Name" 
    },
    primary_phone_number_placeholder: {
        id: "supplier.page.supplier_page.phone_number_placeholder",
        defaultMessage: "Phone Number" 
    },
    mobile_phone_number_placeholder:{
        id: "supplier.page.supplier_page.mobile_phone_number_placeholder",
        defaultMessage: "Mobile Phone Number" 
    },
    email_format_error: {
        id:"customer.modal.add_form.email_field_error",
        defaultMessage:"Please ensure the email is filled out properly",
    },
    phone_format_error: {
        id:"customer.modal.add_form.phone_field_error",
        defaultMessage:"Please ensure the phone is filled out properly",
    },
    empty_email_error:{
        id: "supplier.page.supplier_page.empty_email_error_placeholder",
        defaultMessage: "Empty Email" 
    },
    empty_number_error: {
        id: "contact.forms.supplier_form.empty_number_error",
        defaultMessage: "Empty Number"    
    },
    namePlaceholder:{
        id: "supplier.page.supplier_page.new.name_placeholder",
        defaultMessage: "Enter supplier name"
    },
    nameMissingError: {
        id: "supplier.page.supplier_page.new.name_missing.error_message",
        defaultMessage: "Supplier name required"
    },
    supplierCompanyLabel: {
        id: "supplier.page.supplier_page.new.create_new.company_name_label",
        defaultMessage: "Company name"
    },
    companyNamePlaceholder: {
        id: "supplier.page.supplier_page.new.create_new.company_name_placeholder",
        defaultMessage: "Select or type company name"
    },
    supplierEmailLabel:{
        id: "supplier.page.supplier_page.new.email_label",
        defaultMessage: "Email" 
    },
    emailPlaceholder:{
        id: "supplier.page.supplier_page.new.email_placeholder",
        defaultMessage: "Enter email"
    },
    countryLabel:{
        id: "supplier.page.supplier_page.new.country_label",
        defaultMessage: "Country"
    },
    countryPlaceholder:{
        id: "supplier.page.supplier_page.new.country_placeholder",
        defaultMessage: "Enter country"
    },
    languageLabel: {
        id: "supplier.page.supplier_page.new.language_label",
        defaultMessage: "Supplier language"
    },
    notesLabel:{
        id: "supplier.page.supplier_page.new.notes_label",
        defaultMessage: "Notes"        
    },
    taxNumberLabel:{
        id: "supplier.page.supplier_page.new.tax_number_label",
        defaultMessage: "Tax identification number"
    },
    "emailKeyword": {
        id: "contact.form.edit.duplication_error_message_email",
        defaultMessage: "Contact using this email already exists:",
    },
    "phoneNumberKeywordCheckDup": {
        id: "contact.form.edit.duplication_error_message_phone",
        defaultMessage: "Contact using this phone number already exists:",
    }
})


// WEBPACK FOOTER //
// ./src/customer/supplier/components/listing/messages.ts